import { CurrencyModel } from "./CurrencyModel";
import { stringObjectModel } from "./genericModel";

export class AppConstants {
  
  public static get user(): string { return 'sys@clavisco.com'; }
  //public static get user(): string { return 'dev@clavisco.com'; }
  public static get password(): string { return 'Cl@v1sC02021'; }


  public static get getCurrencyList(): CurrencyModel[] {
    return JSON.parse(JSON.stringify(this.CurrencyList));
  }

  private static CurrencyList: CurrencyModel[] = [
    {
      Currency: 'COL',
      CurrencyName: 'Colones'
    },
    {
      Currency: 'USD',
      CurrencyName: 'Dolares'
    }
  ];

  public static get getDaysOfWeekDaysList(): stringObjectModel[] {
    return JSON.parse(JSON.stringify(this.DaysOfWeekDaysList));
  }

  private static DaysOfWeekDaysList: stringObjectModel[] = [
    { Id: 'L', Value: 'Lunes' },
    { Id: 'K', Value: 'Martes' },
    { Id: 'M', Value: 'Miércoles' },
    { Id: 'J', Value: 'Jueves' },
    { Id: 'V', Value: 'Viernes' },
    { Id: 'S', Value: 'Sábado' },
    { Id: 'D', Value: 'Domingo' }
  ];



  public static CondicionVenta = [
    {
      'Id': '01',
      'Name': 'Contado',
    }
  ];
  
  public static CondicionVentaFE = [
    ...this.CondicionVenta,
    {
      "Id": "12",
      "Name": "Venta de Mercancía No Nacionalizada"
    },
    {
      "Id": "13",
      "Name": "Venta Bienes Usados No Contribuyente"
    },
  ].sort((a, b) => a.Id.localeCompare(b.Id));
  
}